import util from '../lib/util';
import newHRTimestamp from '../lib/picos/timestamp';
import type {uuid, SchemaField, EntitySchema} from "../@types/schema";
import Base from "./base";
import {genUUID} from "../lib/picos/uuids";
import type {EntityType} from "../@types/entity";
function getCurrentUserId() { return sessionStorage.getItem('userId'); }
function getCurrentFirmId() { return sessionStorage.getItem('firmId'); }
class Lawpay extends Base implements EntityType {
    lawpayId: uuid;
    name?: string | null;
    accountType?: string | null;
    currency?: string | null;
    recurringChargesEnabled: boolean;
    theirId?: string | null;
    publicKey?: string | null;
    secretKey?: string | null;
    trustAccount: boolean;
    token?: string | null;
    constructor(doc: typeof Lawpay | any) {
        super(doc);
        if (!doc) doc = {
            firmId: getCurrentFirmId(),
            addedBy: getCurrentUserId(),
            addedOn: newHRTimestamp(),
            status: "C",
            entityId: null,
            entityType: null,
            lawpayId: null,
        };
        // @ts-ignore
        this.entityId = doc._entityId || doc.entityId || doc.entityid || '00000000-0000-0000-0000-000000000000';
        // @ts-ignore
        this.entityType = doc._entityType || doc.entityType || doc.entitytype || "lawpay";
        // @ts-ignore
        this.lawpayId = doc._lawpayId || doc.lawpayId || doc.lawpayid || null;
        // @ts-ignore
        this.name = doc._name || doc.name || null;
        // @ts-ignore
        this.accountType = doc._accountType || doc.accountType || doc.accounttype || null;
        // @ts-ignore
        this.currency = doc._currency || doc.currency || null;
        // @ts-ignore
        this.recurringChargesEnabled = util.defaultBoolean([doc.recurringChargesEnabled, doc._recurringChargesEnabled, doc.recurringchargesenabled, false]);
        // @ts-ignore
        this.theirId = doc._theirId || doc.theirId || doc.theirid || null;
        // @ts-ignore
        this.publicKey = doc._publicKey || doc.publicKey || doc.publickey || null;
        // @ts-ignore
        this.secretKey = doc._secretKey || doc.secretKey || doc.secretkey || null;
        // @ts-ignore
        this.trustAccount = util.defaultBoolean([doc.trustAccount, doc._trustAccount, doc.trustaccount, false]);
        // @ts-ignore
        this.token = doc._token || doc.token || null;
    }
    get id(): uuid { return this.lawpayId; }
    static override getPkFields(): SchemaField[] { return [{"type":"uuid","required":true,"pk":true,"comment":"Our internal ID for this LawPay account record (see theirId for LawPay's own ID)"},{"type":"uuid","required":true,"pk":true,"base":true,"default":"__FIRM__","mergeStrategy":"immutable","comment":"Associated firm"}]; }
    toLowerCase() { return this.lawpayId; }
    static override getNonRefArrayFields(): string[] { return []; }
    static override getDefaultEntries(): Lawpay[] {
        return [];
    }
    static override getSchema(): EntitySchema {
        return Base.withBaseFields({
    entity: 'lawpay',
    dataArea: 'Trust and Payments',
    clientStore: false,
    table: 'LAWPAY',
    comment: 'A LawPay merchant account connected to a firm for processing client payments. Stores the API credentials (public key, secret key, and gateway token) needed to charge clients through the LawPay payment gateway. A firm may have multiple accounts; the trustAccount flag distinguishes operating accounts from trust (IOLTA) accounts.',
    fields: {
        lawpayId: {type: 'uuid', required: true, pk: true, comment: `Our internal ID for this LawPay account record (see theirId for LawPay's own ID)`},

        name: {type: 'string', comment: 'Name of the account'},

        accountType: {type: 'string', comment: 'Type of account, e.g. MerchantAccount'},

        currency: {type: 'string', comment: 'Currency (e.g. USD)'},

        recurringChargesEnabled: {type: 'boolean', comment: 'Are recurring charges enabled for this account?'},

        theirId: {type: 'string', comment: `LawPay's own ID for this account`},

        publicKey: {type: 'string', encrypted: true, comment: 'Public key for this account'},

        secretKey: {type: 'string', encrypted: true, comment: 'Secret key for this account'},

        trustAccount: {type: 'boolean', comment: 'Is this a trust account?'},

        token: {type: 'string', encrypted: true, comment: 'The token that will be used for accessing the payments API/gateway'}
    }
});
    }
}
export default Lawpay;
